// import { Typography } from "@mui/material";
import styled from "styled-components";

export const OffersStyled = styled.div`
	display: flex;
	justify-content: center;
	padding: 0.4375em;

	&.bouncy-chest {
		flex-direction: column;
	}

	@media (orientation: portrait) {
		width: 100%;
		height: 78%;
		align-items: center;
		flex-direction: column;
		flex-wrap: nowrap;
		&::-webkit-scrollbar {
			width: 0px;
		}

		&.bouncy-chest {
			height: 500px;
		}
	}

	@media (orientation: landscape) {
		height: 58%;
		align-items: center;
		flex-wrap: nowrap;

		&.bouncy-chest {
			position: absolute;
			height: unset;
			min-height: 323px;
			bottom: 50px;
			right: 95px;
		}
	}
`;
